export function installCanvasFullscreenFallback(canvas, activateStageFullscreen) {
  if (!canvas) return () => {};

  const ownRequestFullscreen = canvas.requestFullscreen;
  const nativeRequestFullscreen = typeof ownRequestFullscreen === "function"
    ? ownRequestFullscreen.bind(canvas)
    : null;

  canvas.requestFullscreen = (...args) => {
    activateStageFullscreen();
    if (!nativeRequestFullscreen) return Promise.resolve();

    try {
      return Promise.resolve(nativeRequestFullscreen(...args)).catch(() => undefined);
    } catch {
      return Promise.resolve();
    }
  };

  return () => {
    if (ownRequestFullscreen === undefined) delete canvas.requestFullscreen;
    else canvas.requestFullscreen = ownRequestFullscreen;
  };
}
